const tr = {
  switchOrg: '組織切換成功！正在為您刷新頁面...',
  userInfo: '個人資訊',
  preferences: '系統設置',
  logout: '登出登入',
  invnManag: '倉儲管理',
  orgHouse: '組織倉庫',
  orderList: '訂單列表',
  invnHistory: '盤點歷史',
  salesMana: "銷售管理",
  customMana: "終端客戶管理",
  priceMana: "價格管理",
  orderMana: "訂單管理",
  bomMana: 'BOM管理',
  orgManag: '組織管理',
  memberManag: '成員管理',
  enableMember: '啟用成員',
  disableMember: '禁用成員',
  categoryManag: '商品類目管理',
  productList: '商品列表',
  APPManagement: 'APP管理',
  productData: '生產資料輸入',
  orderReviews: '訂單評審',
  productionInfo: '生產資料製作',
  dataModule: '資料模組',
  orderReport: '訂單報表',
  conLogout: '確定退出嗎？',
  conLogoutTip1: '確定退出後將返回登入頁面。',
  loggingOut: '正在為您登出登入...',
  selectOrg: '請選擇組織',
  themeColor: '主題顏色',
  addSuccess: '添加成功',
  addFailed: '新增失敗',
  updateSuccess: '更新成功',
  updateFailed: '更新失敗',
  validaFailed: '校驗失敗',
  cancel: '取消',
  confirm: '確定',
  Loading: '載入中',
  upFail: '上傳失敗',
  plTryAgain: '請稍後再試',
  changeTip: '語言設定',
  switchOrgFailTip1: '當前組織無許可權，無法進行切換！',
  switchOrgFailTip2: '組織切換失敗，請重試！',
  loginFailTip1: '帳戶不是後臺管理員，請返回至用戶登錄。',
  loginFailTip2: '該帳戶沒有參與組織或者沒有許可權，請聯系管理員。',
  userAbnormalTip: '使用者狀態异常或許可權不足，請聯系管理員或重新登入！',
  orderProductionReports: '訂單生產報表',
  orderReview: '訂單評審',
  orderProductionData: '訂單生產數據',
  purchaseMana: '採購管理',
  supplierMana: '供應商管理',
  materialControl: '物控管理',
  requirementList: ' 需求清單',
  noPassRequirement: ' 未審批需求清單',
  passedRequirement: ' 已審批需求清單',
  prod: ' 生產管理',
  finance: ' 財務管理',
  generatePurOrder: '生成采購訂單',
  isAdmin: '系统管理员',

  okOrder: '銷售正式訂單',
  saleOrderFinish: '銷售訂單完結',
  waitOk: '需求評審',
  noPass: '評審待處理',
  passed: '需求已評審',
  purOrder: ' 採購訂單管理',
  orderRe: '銷售評審單',
  disableAndEnable: '禁用啓用',
  memberOperation: '成員操作',
  commodityEditor: '商品編輯',
  subcategoryEditing: '子類目編輯',
  orgOperation: '組織操作',
  reject: '需求退回',
  orgMana: "組織管理",
  orgInfoUpdate: "組織資訊修改",
  orgMemberUpdate: "組織成員修改",
  wareMana: "倉庫管理",
  inboundMana: "入庫管理",
  outboundMana: "出庫管理",
  inventoryMana: "盤點管理",
  orderTrack: '訂單跟踪',
  pendingOrder: '未完成',
  doneOrder: '已完成',
  closeOrder: '已關閉',
  mcDataMt: '物控資料維護',
  mcReTemp: '物控需求模版',
  orderEntry: '訂單資料錄入',
  orderProdMt: '生產資料維護',
  purPendingPay: '未下單',
  purPayed: '已下單',
  purDone: '已完成',
  purOrderMt: '採購資訊維護',
  requirementPurchase: '採購製單',
  reqM: '備料計劃',
  DATAManage: '資料管理',
  QutationManage: '問詢單管理',
  typeManage: '商品類目管理',
  submit: '保存',
  gategoryManage: '報價商品列表',
  printSetting: '打印設定',
  quotationManage: '報價管理',
  setExchange: '匯率設定',
  mainCurrency: '本位貨幣',
  company: '公司名稱',
  address: '公司地址',
  plzCompany: '請輸入公司名稱',
  plzAddress: '請輸入公司地址',
  orderManage: '訂單管理',
  warehousePreparation: '出入庫準備',
  warehouseManagement: '出入庫管理',
  operationStatus: '操作狀態',
  locationManagement: '庫位管理',
  commodity: '產品管理',
  upSucc: "檔案上傳成功",
  addressM: "送貨地址管理",
  addAddress: "添加地址",
  editAddress: "修改地址",
  inventoryManage: "庫存管理",
  purchaseOperation: "採購操作",
  manualQuotation: "人工報價",
  materialTracking: "齊料追蹤",
  returnAndExchange: "退換貨",
  pleaseFillRate: "請填寫匯率",
  uploadImage: "上傳圖片",
  pleaseEnterName: "請輸入名稱",
  pleaseEnterAddress: "請輸入地址",
  orderReportAll: "訂單報表_全部",
  disabledSupplier: "已停用供應商",
  confirmDisableSupplier: "確定停用嗎？",
  confirmDisableSupplierDesc: "這將停用此供應商",
  confirmEnableSupplier: "確定啟用嗎？",
  confirmEnableSupplierDesc: "這將啟用此供應商",
  reimburseCategory: "報銷類目",
  approveTemplate: "審批模板",
  reimburseMana: "申請審批",
  myApplication: "我的申請",
  pendingApproval: "待我審批",
  allApplications: "全部申請",
  inOutDetail: "出入庫明細",
  locationRefProducts: "庫位商品關聯",
  priceList: "採購價格列表",
  inventoryAlert: "庫存預警",
  setInventoryAlert: "添加庫存預警",
  purchaseRule: "採購條約",
  addPurchaseRule: "添加採購條約",
  ruleLangsPl: "請選擇要添加的採購條約語言版本(如果沒有你想添加的語言，請去系統設置裡面完善)",
  printRule: "添加條約",
  notPrintRule: "不添加條約",
  noRuleConfig: "沒有填寫任何語言的採購條約，如需打印採購條約，請去系統設置中完善",
  purchaseRuleSet: "採購條約設置",
  factoryInventory: "產線倉庫",
  equipmentManagement: "設備管理",
  width: "紙寬（豎版連續）",
  height: "紙高（豎版連續）",
  printTip: "系統打印紙張設置：{{width}}mm X {{height}}mm",
  printTipVertical: "豎版連續打印紙張設置（寬 X 高）",
  purInvItem: "送貨單明細",
  locInvDetail: "庫位出入庫明細",
};

export default tr;
